// Shared free-tier gate copy (expansion date window, signal blur, API keys).
export default {
  premium: {
    tag: "PRO",
    gate: {
      signalsTitle: "최근 {n}개의 시그널이 잠겨 있습니다",
      signalsDesc:
        "업그레이드하면 각 기업의 첫날부터 모든 확장 시그널을 볼 수 있습니다.",
      signalsCta: "시그널 잠금 해제",
    },
    dateWindow: {
      tip: "무료 요금제는 최근 {n}일까지 지원됩니다. 전체 기록은 업그레이드하세요.",
      lockedLabel: "전체 기록 보려면 업그레이드",
    },
    apiKeys: {
      bannerTitle: "API 액세스는 유료 기능입니다",
      bannerDesc:
        "키를 생성하고, 내보내기를 자동화하며, Pubrio를 프로그래밍 방식으로 조회하세요.",
      tip: "API 키를 생성하려면 요금제를 업그레이드하세요.",
      cta: "요금제 보기",
    },
    team: {
      locked: "팀 보기",
      tip: "이 시장의 현지 팀을 보려면 업그레이드하세요.",
    },
    source: {
      locked: "출처 보기",
      tip: "각 시그널의 출처를 열려면 업그레이드하세요.",
    },
    employees: {
      locked: "직원 데이터가 잠겨 있습니다",
      tip: "이 회사의 인원수와 담당자를 보려면 업그레이드하세요.",
      cta: "직원 잠금 해제",
    },
    markets: {
      moreLocked: "+{n}개 시장 더",
    },
  },
};
